module.exports = "varying vec2 vUv;\r\n\r\nuniform sampler2D vignette;\r\nuniform vec2 SCREEN_SIZE;\r\nuniform float time;\r\n\r\nvoid main() \r\n{\r\n    vec2 pixelSize = vec2(1.0 / SCREEN_SIZE.x, 1.0 / SCREEN_SIZE.y);\r\n    float displSmall = sin(vUv.y * SCREEN_SIZE.y) * .5 + .5;\r\n    \r\n    vec4 color = texture2D(vignette, vUv);\r\n\tgl_FragColor = mix(color, vec4(.5), displSmall);\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/overlays/vignette.frag.glsl
// module id = 46
// module chunks = 0